import {
  Flex,
  FlexProps,
  HStack,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from '@chakra-ui/react';
import { FC } from 'react';

import NotificationIcon from '@/assets/icons/ic-notification.svg';

import { PopoverButton } from '@/components/ui/core/PopoverButton/PopoverButton';
import { NotificationBadge } from '@/components/ui/shared/notifications/NotificationBadge/NotificationBadge';
import { Notifications } from '@/components/ui/shared/notifications/Notifications/Notifications';
import { ErrorFallback } from '@/components/ui/shared/overlays/ErrorFallback/ErrorFallback';
import { BugsnagErrorBoundary } from '@/components/ui/shared/utilities/BugsnagErrorBoundary/BugsnagErrorBoundary';
import { ResourceType } from '@/enums/ResourceType';

// const DynamicDirectMessaging = dynamic(
//   () =>
//     import('@/components/ui/shared/direct-messaging/DirectMessaging/DirectMessaging').then(
//       (mod) => mod.DirectMessaging
//     ),
//   {
//     ssr: false,
//     loading: () => (
//       <Flex alignItems="center" justifyContent="center" h="full">
//         <CircleLoader size="lg" color="gray.200" />
//       </Flex>
//     ),
//   }
// );

interface ISecondaryMenuDesktopProps extends FlexProps {
  headerHeight?: number;
  popoverBottomOffset?: number;
}

export const SecondaryMenuDesktop: FC<ISecondaryMenuDesktopProps> = ({
  headerHeight,
  popoverBottomOffset = 16,
  ...rest
}) => {
  return (
    <Flex {...rest}>
      <HStack spacing={2}>
        <Popover variant="nav" isLazy placement="bottom-end">
          <PopoverTrigger>
            <PopoverButton variant="nav">
              <NotificationBadge resourceType={ResourceType.Lecture}>
                <NotificationIcon />
              </NotificationBadge>
            </PopoverButton>
          </PopoverTrigger>
          <Portal>
            <PopoverContent h={`calc(100vh - ${headerHeight}px - ${popoverBottomOffset}px)`}>
              <PopoverBody>
                <BugsnagErrorBoundary FallbackComponent={ErrorFallback}>
                  <Notifications />
                </BugsnagErrorBoundary>
              </PopoverBody>
            </PopoverContent>
          </Portal>
        </Popover>
      </HStack>
    </Flex>
  );
};
